export default __webpack_public_path__ + "static/media/aws-dynamodb.ec95976ef79877ae1170da2614198210.svg";